import React from "react";
import * as ReactSpinners from 'react-spinners';
import { css } from 'styled-components'

const Spinner = ({ type = null, ...props }) => {
    const Loader = type ? ReactSpinners[type] : ReactSpinners.MoonLoader;
    const defaultStyle = css`
        margin: 0 auto;
    `
    // 설정 부분 코딩 필요 (크기, 높이 등)

    return <Loader css={defaultStyle} {...props}/>
};

export default Spinner;
